/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const privacyAPI = {
  listaRichieste: async () => { const { data } = await apiClient.get('/privacy/richieste'); return data; },
  anonimizza: async (id) => { const { data } = await apiClient.post(`/privacy/richieste/${id}/anonimizza`); return data; },
  rifiuta: async (id, note) => { const { data } = await apiClient.post(`/privacy/richieste/${id}/rifiuta`, { note }); return data; },
};
